export enum CreditPolicyValueType {
  MaxSingleInput = 0,
  MinSingleInput,
  DropDownOptions,
  Range,
  Boolean,
  ToBeDerived
}